import EventEmitter from 'eventemitter3';
import { Events } from '../types/events.type';

// Create a shared instance of EventEmitter
const eventsService = new EventEmitter<Events>();
export default eventsService;